import styled, { createGlobalStyle } from "styled-components";

export const RelatorioEncomendasContainer = styled.div`
  width: 100%;

  .spinner {
    left: 0;
    top: 0;
  }
`;

export const RelatorioFiltrosForm = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  margin-bottom: 20px;

  .formulario-titulo {
    text-align: left;
    margin-bottom: 20px;
    h2 {
      font-size: 1.8rem;
      font-weight: bold;
    }
  }

  .formulario-linha {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;

    .formulario-busca-input-area {
      flex: 1 1 200px;
      min-width: 180px;
      text-align: left;

      label {
        display: block;
        margin-bottom: 4px;
        white-space: nowrap;
      }

      .input,
      .select select {
        width: 100%;
      }

      input[type="date"] {
        position: relative;
        padding-right: 2rem;
      }

      input[type="date"]::-webkit-calendar-picker-indicator {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
  }

  .multiselect-custom {
    width: 100%;
    padding: 0.5rem 0.5rem !important;
  }

  .p-multiselect,
  .p-multiselect-panel,
  .p-multiselect-item,
  .p-multiselect-filter-container input {
    font-size: 1em;
    font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,
      "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }

  .formulario-acoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .button.buscar-button {
    background: linear-gradient(267deg, rgb(131, 43, 146) 39%, rgb(160, 69, 176) 100%);
    border: none;
    color: white;
    font-weight: 600;
    letter-spacing: 0.2px;
    min-width: 120px;
  }

  .button.buscar-button:hover {
    opacity: 0.8;
  }

  .button.exportar-button {
    background: linear-gradient(267deg, rgb(131, 43, 146) 39%, rgb(160, 69, 176) 100%);
    border: none;
    color: white;
    font-weight: 600;
    letter-spacing: 0.2px;
    min-width: 140px;
  }

  .button.exportar-button:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    padding: 20px;

    .formulario-linha {
      flex-direction: column;
    }

    .formulario-acoes {
      flex-direction: column;
      align-items: stretch;

      button {
        width: 100%;
      }
    }
  }
`;

export const TabelaWrapper = styled.div`
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow-x: auto;
  width: 100%;

  .tabela-cabecalho {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 0.5rem;

    h2 {
      font-size: 1.8rem;
      font-weight: bold;
    }

    .tabela-controles {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;

      .select {
        min-width: 160px !important;
        height: 3rem !important;
      }

      .select select {
        width: 100% !important;
        height: 100% !important;
        font-size: 1rem !important;
        font-weight: 600 !important;
      }
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
    min-width: 1400px;

    th,
    td {
      padding: 8px 10px;
      border-bottom: 1px solid #f0f0f0;
      white-space: nowrap;
      text-align: left;
    }

    th {
      background-color: #f8f8f8;
      font-weight: 600;
      color: #4a4a4a;

      &.sortable {
        cursor: pointer;
        user-select: none;

        &:hover {
          color: rgba(136, 48, 152, 1);
        }

        .sort-icon {
          margin-left: 4px;
          font-size: 0.75rem;
          color: rgba(136, 48, 152, 1);
        }
      }
    }

    th.group-start {
      border-left: 2px solid rgba(136, 48, 152, 0.2);
    }

    tbody tr:hover {
      background-color: #faf5fc;
    }

    td a {
      color: rgba(136, 48, 152, 1);
      text-decoration: underline;
    }
  }

  .tabela-vazia {
    text-align: center;
    padding: 40px;
    color: #888;
    font-size: 1rem;
  }

  .tabela-rodape {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .button.loadmore-button {
    color: rgba(136, 48, 152, 1);
    border-color: rgba(136, 48, 152, 1);
    font-weight: 600;
    min-width: 160px;
  }

  .button.loadmore-button:hover {
    background-color: rgba(136, 48, 152, 0.05);
  }
`;

export const MultiSelectGlobalStyle = createGlobalStyle`
  .custom-filter-panel .p-multiselect-panel {
    z-index: 9999;
  }

  .custom-filter-panel .p-multiselect-item {
    column-gap: 8px !important;
  }
`;
